import { useCallback } from "react";
function useFieldHelperText({
  submitCount,
  trigger,
  errors
}) {
  const triggerError = useCallback(async (fieldName) => {
    await trigger(fieldName);
  }, [trigger]);
  const shouldShowError = useCallback((fieldName) => {
    const hasError = !!(errors == null ? void 0 : errors[fieldName]);
    return hasError && submitCount > 0;
  }, [errors, submitCount]);
  return {
    triggerError,
    shouldShowError,
    submitCount
  };
}
export {
  useFieldHelperText as default
};
